import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";

const keyList = {
    smsUpdate : 'CATEGORY_UPDATE',
    smsDelete : 'CATEGORY_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,
    state : {
        categories: [],
        sub_categories:[],
        category_detail: {},
        designation_by_category:[],

        employee_by_designation:[],
        
        categoryLoading: false,
        categoryError: false,

        submitLoading: false,
        submitError: false,
        submitSuccess: false,
        subcategoryLoading:false,
        subcategoryError:false,


        products: [],
        product_without_pg:[],
        product_count:null,
        product_details: {},
        productLoading: false,
        productError: false,

        inventoryUnits:[],
        inventoryLoading: false,
        inventoryError: false,

        ...store
    },

    mutations : {
        ...mutations,
        SET_CATEGORY (state, category) {
            state.categories = category;
        },
        CATEGORY_LOADING (state, loading) {
            state.categoryLoading = loading;
        },

        CATEGORY_ERROR (state, loading) {
            state.categoryError = loading;
        },

        SUBMIT_LOADING (state, loading) {
            state.submitLoading = loading;
        },

        SUBMIT_ERROR (state, hasError) {
            state.submitError = hasError;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },
        SUB_CATEGORY_LOADING(state, loading) {
            state.subcategoryLoading = loading;
        },

        SUB_CATEGORY_ERROR (state, loading) {
            state.subcategoryError = loading;
        },
        SET_SUB_CATEGORY(state, category) {
            state.sub_categories = category;
        },

        SET_PRODUCT (state, {results,pg_count}) {
            state.products = results;
            state.product_count = pg_count;
        },

        SET_PRODUCTS_WITHOUT_PG (state, product) {
            state.product_without_pg = product;
        },

       
       
        SET_PRODUCT_DETAILS (state, product) {
            state.product_details = product;
        },
        PRODUCT_LOADING (state, loading) {
            state.productLoading = loading;
        },

        PRODUCT_ERROR (state, loading) {
            state.productError = loading;
        },
        SET_INVENTORY_UNITS(state, data) {
            state.inventoryUnits = data;
        },
        INVENTORY_LOADING (state, loading) {
            state.inventoryLoading = loading;
        },

        INVENTORY_ERROR (state, loading) {
            state.inventoryError = loading;
        },



    },

    actions: {
        async fetchInvertoryUnits ({ commit }) {
            commit('INVENTORY_LOADING', true);
            commit('INVENTORY_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };
            try{
                let result = await axios.get(V1API.get_inventory_units, config);
                let response = result.data.data
                commit('SET_INVENTORY_UNITS', response);
                return response

            } catch(error) {
                commit('INVENTORY_ERROR', true);
            }
            finally{
                commit('INVENTORY_LOADING', false);
            }
        },

        async updateCategory ({commit, state, dispatch}, payload) {
            let response='';
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            await performNetworkCall(
                commit,
                keyList.smsUpdate,
               
                async () => {
                    response= await axios.patch(V1API.update_category+payload.id,
                        {name:payload.name}
                        ,config).then(result=>{
                        let data=decode(result.data)
                        return data
                    })
                    dispatch('fetchCategories');
                }
            )
            return response
        },
        
        async deleteCategory ({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.delete_category + payload, config).then(result=>{
                let data = result.data
                return data
            })

            dispatch('fetchCategories');
            return response
        },

        async fetchCategories ({ commit }) {
            commit('CATEGORY_LOADING', true);
            commit('CATEGORY_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_all_categories, config);
                let response = result.data.data
                commit('SET_CATEGORY', response);

            } catch(error) {
                commit('CATEGORY_ERROR', true);
            }
            commit('CATEGORY_LOADING', false);
        },
        async fetchSubCatByCat ({ commit } , payload) {
            commit('SUB_CATEGORY_LOADING', true);
            commit('SUB_CATEGORY_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_subcat_by_cat + payload, config);
                let response = result.data.data
                commit('SET_SUB_CATEGORY', response);

            } catch(error) {
                commit('SUB_CATEGORY_ERROR', true);
            }
            finally{
                commit('SUB_CATEGORY_LOADING', false);
            }
        },

        async addCategory ({commit, dispatch}, payload) {
            commit('CATEGORY_LOADING', true);
            commit('CATEGORY_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let response = await axios.post(V1API.create_category, payload, config).then(result=>{ 
                    let data = result.data
                    return data
                });
                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchCategories')
                return response

            }catch (e) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('CATEGORY_LOADING', false);
            }
        },



        // Products


        async updateProduct ({commit, state, dispatch}, payload) {
            let response='';
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            await performNetworkCall(
                commit,
                keyList.smsUpdate,
               
                async () => {
                    response= await axios.patch(V1API.update_product+payload.id,
                         payload.product
                        ,config).then(result=>{
                        let data=decode(result.data)
                        return data
                    })
                   
                }
            )
            return response
        },

        async toggleProductStatus ({dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.get(V1API.product_toggle_status + payload.id, config).then(result=>{
                let data = result.data
                return data
            })

            dispatch('fetchProducts', 
                {
                currentPage:payload.currentPage, 
                perPage:payload.perPage, 
                start_date:payload.start_date, 
                end_date:payload.end_date, 
                search_term:payload.search_term, 
                vendor:payload.vendor, 
                project:payload.project, 
                employee:payload.employee});

            return response
        },


        async deleteProduct ({dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.delete_product + payload.id, config).then(result=>{
                let data = result.data
                return data
            })

            dispatch('fetchProducts', 
                {
                currentPage:payload.currentPage, 
                perPage:payload.perPage, 
                start_date:payload.start_date, 
                end_date:payload.end_date, 
                search_term:payload.search_term, 
                vendor:payload.vendor, 
                project:payload.project, 
                employee:payload.employee});

            return response
        },
        


        async fetchProducts ({ commit }, payload) {
            commit('PRODUCT_LOADING', true);
            commit('PRODUCT_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let params = new URLSearchParams();
        
                if (payload.perPage) params.append('count', payload.perPage);
                if (payload.currentPage) params.append('page', payload.currentPage);
                if (payload.search_term) params.append('search_term', payload.search_term);
                if (payload.start_date) params.append('start_date', payload.start_date);
                if (payload.end_date) params.append('end_date', payload.end_date);
                if (payload.status) params.append('status', payload.status);
                if (payload.client) params.append('client', payload.client);
                if (payload.project) params.append('project', payload.project);
                if (payload.employee) params.append('employee', payload.employee);
                
                let url = V1API.get_all_products + '?' + params.toString();
                let result = await axios.get(url, config);
                const {results,pg_count} = result.data

                commit('SET_PRODUCT', {results,pg_count});
                return result

            } catch(error) {
                commit('PRODUCT_ERROR', true);
            }
            finally {
                commit('PRODUCT_LOADING', false);
            }
        },


        async fetchProductDetails ({ commit },payload) {
            commit('PRODUCT_LOADING', true);
            commit('PRODUCT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_product_details + payload, config);
                let response = result.data.data
                commit('SET_PRODUCT_DETAILS', response);

            } catch(error) {
                commit('PRODUCT_ERROR', true);
            }
           finally{
             commit('PRODUCT_LOADING', false);
           }
        },
        
        
        async addProduct ({commit, dispatch}, payload) {
            commit('PRODUCT_LOADING', true);
            commit('PRODUCT_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let response = await axios.post(V1API.create_product, payload, config).then(result=>{ 
                    let data = result.data
                    return data
                });
                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchProducts')
                return response

            }catch (e) {
                commit('PRODUCT_ERROR', true);
            }finally {
                commit('PRODUCT_LOADING', false);
            }
        },

        
        async fetchProductWithoutPG ({ commit }) {
            commit('PRODUCT_LOADING', true);
            commit('PRODUCT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_all_products_withoutpg, config);
                let response = result.data.data
                commit('SET_PRODUCTS_WITHOUT_PG', response);
                 return response


            } catch(error) {
                commit('PRODUCT_ERROR', true);
            }
            finally{
                commit('PRODUCT_LOADING', false);
            }
        },


        //Stock 
        


        async addProductLot ({commit, state, dispatch}, payload) {
            let response='';
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            await performNetworkCall(
                commit,
                keyList.smsUpdate,
               
                async () => {
                    response= await axios.post(V1API.add_product_lot,
                        payload.product_info
                        ,config).then(result=>{
                        let data=decode(result.data)
                        return data
                    })
                   
                }
            )
            return response
        },
          async updateProductLot ({commit, state, dispatch}, payload) {
            let response='';
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            await performNetworkCall(
                commit,
                keyList.smsUpdate,
               
                async () => {
                    response= await axios.patch(V1API.edit_product_lot+payload.id,
                         payload.product_info
                        ,config).then(result=>{
                        let data=decode(result.data)
                        return data
                    })
                   
                }
            )
            return response
        },

    },

    getters: {}
}
